import React, { useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { connectSearchBox } from "react-instantsearch-dom"

import styles from "./CustomSearchBox.module.scss"

const SearchBox = ({ refine, currentRefinement, onFocus }) => {
  const { t } = useTranslation()

  const inputRef = useRef(null)

  useEffect(() => {
    setTimeout(function () {
      inputRef.current.focus()
    }, 400)
  }, [])

  return (
    <div className={styles.searchInputWrapper}>
      <div className={styles.searchInputIcon} />
      <input
        id="site_search"
        ref={inputRef}
        onChange={(e) => refine(e.target.value)}
        value={currentRefinement}
        onFocus={onFocus}
        className="form-control"
        placeholder={t("Hello! What are you looking for?")}
      />
      <button type="submit" className="screen-reader-text">
        {t("Submit Search")}
      </button>
    </div>
  )
}

const CustomSearchBox = connectSearchBox(SearchBox)

export default CustomSearchBox
